import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=13f70599&lang=pug"
import script from "./Plan.vue?vue&type=script&lang=js"
export * from "./Plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardAepPlanRecommendation: require('/home/docker/code/frontend/components/card/AepPlanRecommendation.vue').default,CardPlanLegacy: require('/home/docker/code/frontend/components/card/PlanLegacy.vue').default})
